<!--
 * @Descripttion: hqx
 * @version: 1.0.0
 * @Author: zxx
 * @Date: 2023-07-18 09:49:33
 * @LastEditTime: 2023-07-25 15:47:54
-->
<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view></router-view>
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { mapActions } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      locale: zhCN
    }
  },
  created() {
    this.$store.dispatch('forecast/getWebsiteStandard')
    this.getNowIsHaveTyphoonAction()
  },
  methods: {
    ...mapActions({
      getNowIsHaveTyphoonAction: 'forecast/getNowIsHaveTyphoonAction'
    })
  }
}
</script>

<style lang="scss">
// @import '~@/styles/variable.scss';
html,
body,
#app {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  // background: var(--bg-primary);
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
